import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-77d33db4")
const _hoisted_1 = { class: "show-map-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "map-wrap",
  id: "mapContainer"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}